import { MoretwolineSVG } from "src/assets/svg";

const balanceCard = () => {
  return (
    <div className="bg-white rounded-lg shadow-lg px-6 py-6 relative">
      <div className="flex justify-center items-center mb-6">
        <div className="text-lg text-center leading-none text-light-gray font-bold">
          Total balance
        </div>
        <div className="absolute top-5 right-6">
          <MoretwolineSVG />
        </div>
      </div>
      <div className="text-xl text-black font-bold mb-6">Rp 1.580.000.000</div>
      <div className="flex justify-center">
        <button className="bg-light-blue w-full text-white py-4 rounded-xl px-8 text-lg font-medium mx-auto">
          <div className="text-lg font-bold">Top up</div>
        </button>
      </div>
    </div>
  );
};

export default balanceCard;
